import JobListingBody from "./JobListingBody";

export default JobListingBody;